import { canv } from "@/canv/global";
import { escapeString } from "@/canv/utils";
import { CONSTRUCTORS_WITHOUT_ANCHORS } from "@/constants";
import { CommentWidget } from "@/elements/comment";
import { Group } from "@/group";
import { t } from "@/i18n";
import { clamp } from "@/shared/lib/clamp";
import { toolBase } from "@/tools/toolBase";
import { queryAreaByGroup } from "@/utils";

const COMMENT_MODAL_VIEWPORT_PADDING = 12;
const COMMENT_MODAL_ICON_OFFSET = 43;
const COMMENT_MODAL_INITIAL_HEIGHT = 44;

export class CommentTool extends toolBase {
    getToolView() {
        return `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path stroke="currentColor" d="M12 21C13.78 21 15.5201 20.4722 17.0001 19.4832C18.4802 18.4943 19.6337 17.0887 20.3149 15.4442C20.9961 13.7996 21.1743 11.99 20.8271 10.2442C20.4798 8.49836 19.6226 6.89472 18.364 5.63604C17.1053 4.37737 15.5016 3.5202 13.7558 3.17294C12.01 2.82567 10.2004 3.0039 8.55585 3.68509C6.91131 4.36628 5.50571 5.51983 4.51677 6.99987C3.52784 8.47991 3 10.22 3 12C3 13.488 3.36 14.89 4 16.127L3 21L7.873 20C9.109 20.639 10.513 21 12 21Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        `;
    }

    getButtonView() {
        return `
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.37691 0.101632L15.5179 7.31504C16.1726 7.64904 16.1518 8.56958 15.5082 8.88878L1.3673 15.902C0.751945 16.2072 0 15.7592 0 15.1127V11.686C0 9.89561 1.45146 8.44425 3.24185 8.44437C3.49802 8.42389 3.74059 8.26967 3.74059 7.99936C3.74059 7.75359 3.5173 7.55435 3.24185 7.55435C1.45139 7.55423 0 6.10274 0 4.31228V0.886084C0 0.221143 0.774283 -0.205773 1.37691 0.101632Z" fill="#ABABBB"/>
            </svg>
        `;
    }

    getToolTipName() {
        return t("tools.comment");
    }

    getToolHotKey() {
        return "C";
    }

    chooseCursor() {
        document.body.style.cursor =
            "url(data:image/svg+xml;base64,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) 0 24, auto";
    }

    draw() {
        this.chooseCursor();
    }

    TryAction(type: string) {
        if (type === "mouseup") {
            this.createComment();
        }

        canv.redraw();
    }

    heightController = (e: Event): void => {
        if (!this.textarea) return;

        if (this.button) {
            if ((e.target as HTMLTextAreaElement | null)?.value) {
                this.button.disabled = false;
            } else {
                this.button.disabled = true;
            }
        }

        if (this.textarea.value.length > 2000) {
            this.textarea.value = this.textarea.value.substring(0, 2000);
        }

        this.textarea.style.height = "auto";
        const newHeight = this.textarea.scrollHeight;
        this.textarea.style.height = `${newHeight}px`;
        this.locateModal();
    };

    cleanupModal = (): void => {
        if (this.checkReconnect) {
            clearInterval(this.checkReconnect);
        }

        document.getElementById("comment-modal")?.remove();

        document.removeEventListener("mousedown", this.mousedownHandler);
        document.removeEventListener("keydown", this.keydownHandler);
        if (this.textarea) {
            this.textarea.removeEventListener("input", this.heightController);
        }

        canv.appInterface.inputFocused = 0;
        this.textarea = null;
        this.commentPt = null;
        this.commentScreenPt = null;
    };

    private keydownHandler = (event: KeyboardEvent) => {
        if (event.key === "Escape") {
            this.cleanupModal();
        } else if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            this.onSubmit();
        }
    };

    private mousedownHandler = (event: MouseEvent) => {
        const modalElement = document.querySelector("#comment-modal div");
        const target = event.target as Node;
        const clickInside = modalElement?.contains(target);

        if (!clickInside && modalElement) {
            this.cleanupModal();
        }
    };

    private locateModal = () => {
        const modal = document.querySelector<HTMLDivElement>("#comment-modal > div");

        if (!modal || !this.commentScreenPt) {
            return;
        }

        const modalRect = modal.getBoundingClientRect();
        const minLeft = COMMENT_MODAL_VIEWPORT_PADDING + COMMENT_MODAL_ICON_OFFSET;
        const maxLeft = window.innerWidth - modalRect.width - COMMENT_MODAL_VIEWPORT_PADDING;
        const maxTop = window.innerHeight - modalRect.height - COMMENT_MODAL_VIEWPORT_PADDING;

        const left = clamp(
            this.commentScreenPt.x - modalRect.width / 2,
            minLeft,
            Math.max(minLeft, maxLeft),
        );
        const top = clamp(
            this.commentScreenPt.y - COMMENT_MODAL_INITIAL_HEIGHT / 2,
            COMMENT_MODAL_VIEWPORT_PADDING,
            Math.max(COMMENT_MODAL_VIEWPORT_PADDING, maxTop),
        );

        modal.style.left = `${left}px`;
        modal.style.top = `${top}px`;
    };

    showCommentField() {
        if (this.checkReconnect) {
            clearInterval(this.checkReconnect);
        }

        this.checkReconnect = setInterval(() => {
            if (canv.appInterface.reconnectWindow.showed) {
                this.cleanupModal();
            }
        }, 1000);

        const existing = document.getElementById("comment-modal");
        if (existing) existing.remove();

        const p = document.createElement("p");

        const textarea = document.createElement("textarea");
        textarea.classList.add("scrollable");
        textarea.placeholder = t("comments.addComment");
        textarea.setAttribute("maxlength", "2000");
        textarea.rows = 1;

        const button = document.createElement("button");
        button.classList.add("comment-saveButton");
        button.innerHTML = this.getButtonView();

        const modal = document.createElement("div");
        modal.appendChild(p);
        modal.appendChild(textarea);
        modal.appendChild(button);

        const modalWrapper = document.createElement("div");
        modalWrapper.id = "comment-modal";
        modalWrapper.classList.add("comment-modal");
        modalWrapper.appendChild(modal);

        canv.appInterface.inputFocused = 1;

        document.body.appendChild(modalWrapper);
        this.locateModal();
        this.button = button;
        this.textarea = modalWrapper.querySelector("textarea");
        if (this.textarea) {
            this.textarea.focus();
            this.textarea.addEventListener("input", this.heightController);
        }

        button.onclick = () => {
            this.onSubmit();
        };

        document.addEventListener("mousedown", this.mousedownHandler);
        document.addEventListener("keydown", this.keydownHandler);
    }

    createComment() {
        this.commentPt = canv.actionManager.getActionPoint();
        const canvasRect = canv.canvas.getBoundingClientRect();
        this.commentScreenPt = {
            x: canvasRect.left + canv.actionManager.lastX,
            y: canvasRect.top + canv.actionManager.lastY,
        };
        canv.toolBox.switchToByName("cursorTool");

        this.showCommentField();
    }

    onSubmit() {
        const value = this.textarea?.value.trim() || "";
        this.createCommentWidget(value);
        this.cleanupModal();
    }

    createCommentWidget(commentText: string) {
        if (!commentText || !this.commentPt) {
            return;
        }
        const element = new CommentWidget(this.commentPt.x, this.commentPt.y);
        const newGroup = new Group(true);
        element.setParent(newGroup, false);
        element.updateDims();
        element.text = commentText;
        element.accountName = canv.getInitDataProp("userName");
        element.token = canv.getInitDataProp("userToken");
        element.createdAt = new Date().toISOString();

        const foundCandidates = queryAreaByGroup(
            newGroup,
            true,
            false,
            CONSTRUCTORS_WITHOUT_ANCHORS,
        );
        if (foundCandidates.length) {
            const group = foundCandidates[foundCandidates.length - 1];
            element.anchorUID = group.children[0].UID;
        }

        canv.canvasController.addGroup(newGroup);
        canv.eventManager.openRecord();
        canv.eventManager.createBuildEvent("create", newGroup);
        canv.eventManager.closeRecord();

        element.text = escapeString(commentText);
    }

    name = "commentTool";
    private textarea: HTMLTextAreaElement | null = null;
    private button: HTMLButtonElement | null = null;
    private checkReconnect: NodeJS.Timeout | null = null;
    private commentPt: { x: number; y: number } | null = null;
    private commentScreenPt: { x: number; y: number } | null = null;
}
